
// Vacancies Widget
import VacanciesWidget from "../assets/components/vacancies_widget.vue"
Vue.component('vacancies-widget', VacanciesWidget)
